<template>
    <VirtualGamesSidebarContainer>
        <div
            class="nav-sidebar"
            slot-scope="{ items, activeItem, onItemClick }"
        >
            <div class="nav-sidebar__wrapper">
                <Tree
                    :items="items"
                    :activeIds="[activeItem.name]"
                    :showItemCount="false"
                    :showToplevelFlag="false"
                    @itemClick="([item]) => onItemClick(item)"
                />
            </div>
        </div>
    </VirtualGamesSidebarContainer>
</template>

<script>
    import VirtualGamesSidebarContainer from '@app/shared/components/VirtualGames/VirtualGamesSidebarContainer';

    export default {
        components: {
            VirtualGamesSidebarContainer,
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/games/virtuals/components/Sidebar.vue